import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colours } from "../../styles/colours";
import { Icon } from "../icons";
import { Flex } from "../layout";

const Wrapper = styled.div`
  text-align: center;
`;

const EmptyIcon = styled(Icon).attrs({ type: "empty" })`
  font-size: 10em;
  display: block;
  margin: 0.4em auto;
  color: ${colours.grey};
`;

export const NoElements: React.FunctionComponent<{
  item: string;
  children?: React.ReactNode;
}> = ({ item, children }) => {
  const { t } = useTranslation("common");

  return (
    <Flex center>
      <Wrapper>
        <p className="h1">{t('no-items-to-show', { item })}</p>
        <EmptyIcon />
        {children}
      </Wrapper>
    </Flex>
  );
};
